import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Utils
import FeatureFlags from 'util/featureFlags';

// Constants
import { SVG_PATHS } from 'paper/components/CardOptionsPreview/constants';

// Styles
import { BleedWrapper, BleedPath, BleedSVG } from './Bleed.styles';
import './Bleed.less';

const Bleed = ({
  height,
  width,
  verticalBleed,
  horizontalBleed,
  isRounded,
  shape,
  size,
  orientation,
  useSVGBleed,
}) => {
  const widestBleed = verticalBleed >= horizontalBleed ? verticalBleed : horizontalBleed;

  // styles used for the old bleed
  const bleedStyle = {
    top: `${verticalBleed}pt`,
    left: `${horizontalBleed}pt`,
    height: `${height - verticalBleed * 2}pt`,
    width: `${width - horizontalBleed * 2}pt`,
    // make bleed outline wider than necessary extra will be hidden by overflow hidden
    outlineWidth: `${widestBleed * 1.5}pt`,
    pointerEvents: 'none',
  };

  // const used for the bleed line width
  const bleed = widestBleed * 1.5;

  // consts used for the svg viewBox
  const CLASSIC_VIEW_BOX_WIDTH = 361;
  const CLASSIC_VIEW_BOX_HEIGHT = 505;
  const PETITE_VIEW_BOX_WIDTH = 307;
  const PETITE_VIEW_BOX_HEIGHT = 397;
  const VIEW_BOX_WIDTH = size === '5x7' ? CLASSIC_VIEW_BOX_WIDTH : PETITE_VIEW_BOX_WIDTH;
  const VIEW_BOX_HEIGHT = size === '5x7' ? CLASSIC_VIEW_BOX_HEIGHT : PETITE_VIEW_BOX_HEIGHT;
  const VIEW_BOX = `0 0 ${VIEW_BOX_WIDTH} ${VIEW_BOX_HEIGHT}`;

  // consts used to scale the bleed line when rotated to landscape
  const TRANSFORM_SCALE = VIEW_BOX_HEIGHT / VIEW_BOX_WIDTH;

  if (verticalBleed && horizontalBleed) {
    return (
      <>
        {FeatureFlags.get('newPaperShapes') && useSVGBleed ? (
          <BleedWrapper>
            <BleedSVG viewBox={VIEW_BOX}>
              <BleedPath
                id="bleedPath"
                transformScale={TRANSFORM_SCALE}
                orientation={orientation}
                strokeWidth={`${bleed}pt`}
                d={SVG_PATHS[shape][size]}
              />
            </BleedSVG>
          </BleedWrapper>
        ) : (
          <div className="bleed">
            <div
              className={cx('bleed__inner-wrapper', {
                'bleed__inner-wrapper--is-rounded': isRounded,
              })}
            >
              <div className="bleed__line" style={bleedStyle} />
            </div>
          </div>
        )}
      </>
    );
  }

  return null;
};

Bleed.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  verticalBleed: PropTypes.number,
  horizontalBleed: PropTypes.number,
  isRounded: PropTypes.bool,
};

export default Bleed;
